// Fallback fijo en código porque REACT_APP_BACKEND_URL vive en .env local, que no se
// sube al repo (por diseño, junto con las demás credenciales) — sin este respaldo, un
// build hecho en un sistema de CI/CD sin ese .env local (como Netlify) se queda sin URL
// de backend. Cambiar por la URL del backend en producción al entregar el sitio.
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'https://quinlate-proyecto-completo.onrender.com';
